import type { ReactNode } from 'react';

/**
 * I pezzi con cui e' scritta la guida: paragrafo, sottotitolo, elenco di
 * passi, riquadro di attenzione.
 *
 * Stanno separati dal testo per una ragione pratica: chi viene a correggere una
 * frase apre `contenuti.tsx` e trova solo frasi, senza codice di mezzo.
 */

export function P({ children }: { children: ReactNode }) {
  return <p className="text-sm text-neutral-600 leading-relaxed">{children}</p>;
}

export function H({ children }: { children: ReactNode }) {
  return <h4 className="text-sm font-semibold text-gray-900 mt-4 first:mt-0">{children}</h4>;
}

export function Passi({ voci }: { voci: ReactNode[] }) {
  return (
    <ol className="space-y-1.5">
      {voci.map((voce, i) => (
        <li key={i} className="flex gap-2.5 text-sm text-neutral-600 leading-relaxed">
          <span className="flex-shrink-0 w-5 h-5 rounded-full bg-primary-50 text-primary-700 text-[11px] font-semibold flex items-center justify-center mt-0.5">
            {i + 1}
          </span>
          <span>{voce}</span>
        </li>
      ))}
    </ol>
  );
}

/** Le cose che, se non si sanno, fanno danni veri. */
export function Attenzione({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5">
      <p className="text-sm text-amber-900 leading-relaxed">{children}</p>
    </div>
  );
}
